var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AppModal", {
    attrs: { value: _vm.value, "max-width": "500" },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [_vm._v("\n    Metadata Info\n  ")]
        },
        proxy: true,
      },
      {
        key: "text",
        fn: function () {
          return [
            _c(
              "v-list",
              [
                _c(
                  "v-list-tile",
                  [
                    _c("v-list-tile-content", [_vm._v("Key")]),
                    _vm._v(" "),
                    _c("v-list-tile-content", { staticClass: "align-end" }, [
                      _vm._v(_vm._s(_vm.kvPairKey)),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-list-tile",
                  [
                    _c("v-list-tile-content", [_vm._v("Value")]),
                    _vm._v(" "),
                    _c("v-list-tile-content", { staticClass: "align-end" }, [
                      _vm._v(_vm._s(_vm.displayValue)),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasUnits
                  ? _c(
                      "v-list-tile",
                      [
                        _c("v-list-tile-content", [_vm._v("Units")]),
                        _vm._v(" "),
                        _c(
                          "v-list-tile-content",
                          { staticClass: "align-end" },
                          [_vm._v(_vm._s(_vm.units))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-list-tile",
                  [
                    _c("v-list-tile-content", [_vm._v("Comments")]),
                    _vm._v(" "),
                    _c("v-list-tile-content", { staticClass: "align-end" }, [
                      _vm._v(_vm._s(_vm.kvValue.Comment)),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-list",
              [
                _vm.hasFlags
                  ? [
                      _c(
                        "v-list-tile",
                        [
                          _c("v-list-tile-content", [_vm._v("Flag Code")]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { staticClass: "align-end" },
                            [_vm._v("Flag Description")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.kvValue.Flags, function (fl) {
                        return _c(
                          "v-list-tile",
                          { key: fl.Id },
                          [
                            _c("v-list-tile-content", [
                              _vm._v(_vm._s(fl.FlagCode)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              { staticClass: "align-end" },
                              [_vm._v(_vm._s(fl.Description))]
                            ),
                          ],
                          1
                        )
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }